export { StandardView } from './StandardView';
